import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { ControlesLinha, ProcessoInput } from '../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step09Recursos(props: RelatorioCivelStepProps) {
  const {
    novoProcessoRecursos,
    setNovoProcessoRecursos,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <ProcessoInput
                value={novoProcessoRecursos}
                onChange={setNovoProcessoRecursos}
                onAdicionar={() => adicionarProcesso('recursos', novoProcessoRecursos, setNovoProcessoRecursos)}
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}
      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.recursos}
          onDecrementar={() => setQuantidadeLinhas((prev) => ({ ...prev, recursos: Math.max(1, prev.recursos - 1) }))}
          onIncrementar={() => setQuantidadeLinhas((prev) => ({ ...prev, recursos: Math.min(50, prev.recursos + 1) }))}
          onQuantidadeChange={(value: number) => setQuantidadeLinhas((prev) => ({ ...prev, recursos: value }))}
          onAdicionar={() => adicionarMultiplasLinhas('recursos')}
          totalLabel="Total de Processos"
          totalCount={formData.recursos.processos.length}
        />
      )}
      {renderTabelaProcessos('recursos', formData.recursos.processos)}
    </Fragment>
  );
}

